import { render, staticRenderFns } from "./FourOFour.vue?vue&type=template&id=3ab70d22&"
import script from "./FourOFour.vue?vue&type=script&lang=js&"
export * from "./FourOFour.vue?vue&type=script&lang=js&"
import style0 from "./FourOFour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports